var _defs, _path, _path2, _circle, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnDeviceDriver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.144,
    height: 88,
    viewBox: "0 0 120.144 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:#007da0;opacity:0.086;}.d{fill:url(#c);}.e{fill:url(#d);}.f{fill:url(#e);}.g{fill:url(#f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.012,
    y1: 0.258,
    x2: 1.202,
    y2: 0.847,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#44c7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#3791b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c5da1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -1.674,
    y1: -0.576,
    x2: 3.624,
    y2: 2.046,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -1.483,
    y1: -0.482,
    x2: 0.554,
    y2: 0.526,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -8.347,
    y1: -3.879,
    x2: 0.739,
    y2: 0.618,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -1.845,
    y1: -0.66,
    x2: 0.192,
    y2: 0.348,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -9.957,
    y1: -4.676,
    x2: -0.872,
    y2: -0.179,
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.365,163.59l-1.855-2.915a26.8,26.8,0,0,0,3.68-5.253l3.373.749a2.67,2.67,0,0,0,3.185-2.027l1.991-8.965a2.671,2.671,0,0,0-2.027-3.185l-3.375-.749a26.816,26.816,0,0,0-1.11-6.316l2.915-1.856a2.67,2.67,0,0,0,.818-3.686l-4.931-7.748a2.67,2.67,0,0,0-3.686-.818l-2.915,1.856A26.731,26.731,0,0,0,76.176,119l.749-3.375a2.669,2.669,0,0,0-2.027-3.185l-8.965-1.99a2.669,2.669,0,0,0-3.185,2.027L62,115.848a26.725,26.725,0,0,0-6.316,1.112l-1.856-2.915a2.671,2.671,0,0,0-3.686-.819l-7.746,4.931a2.67,2.67,0,0,0-.819,3.686l1.856,2.916a26.676,26.676,0,0,0-3.68,5.251l-3.375-.749a2.672,2.672,0,0,0-3.185,2.029l-1.99,8.965a2.669,2.669,0,0,0,2.027,3.185l3.373.748a26.751,26.751,0,0,0,1.112,6.318L34.8,152.36a2.671,2.671,0,0,0-.819,3.686l4.931,7.748a2.669,2.669,0,0,0,3.686.818l2.916-1.855a26.741,26.741,0,0,0,5.251,3.68l-.749,3.373A2.672,2.672,0,0,0,52.043,173l8.965,1.991a2.672,2.672,0,0,0,3.185-2.027l.748-3.375a26.827,26.827,0,0,0,6.318-1.11l1.855,2.915a2.669,2.669,0,0,0,3.686.818l7.748-4.931A2.669,2.669,0,0,0,85.365,163.59ZM48.876,152.007a17.3,17.3,0,1,1,23.884,5.3A17.3,17.3,0,0,1,48.876,152.007Z",
    transform: "translate(-31.137 -110.383)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60.652,129.873A7.262,7.262,0,1,0,58.426,139.9,7.262,7.262,0,0,0,60.652,129.873Z",
    transform: "translate(-22.193 -101.439)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(14.863)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.388 41.783)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M91.2,172.415l-.311-1.991a15.651,15.651,0,0,0,3.192-1.948l1.629,1.188a1.556,1.556,0,0,0,2.175-.34L101.037,165a1.559,1.559,0,0,0-.339-2.176l-1.629-1.188A15.562,15.562,0,0,0,99.95,158l1.991-.311a1.557,1.557,0,0,0,1.3-1.778l-.827-5.292a1.555,1.555,0,0,0-1.778-1.3l-1.99.311a15.7,15.7,0,0,0-1.948-3.193l1.188-1.628a1.556,1.556,0,0,0-.34-2.175l-4.326-3.157a1.556,1.556,0,0,0-2.175.34l-1.188,1.628a15.56,15.56,0,0,0-3.635-.88l-.311-1.991a1.558,1.558,0,0,0-1.778-1.3l-5.292.827a1.559,1.559,0,0,0-1.3,1.778l.312,1.991a15.526,15.526,0,0,0-3.193,1.948l-1.628-1.188a1.557,1.557,0,0,0-2.175.339L67.7,147.3a1.558,1.558,0,0,0,.34,2.176l1.628,1.188a15.558,15.558,0,0,0-.88,3.635l-1.991.311a1.556,1.556,0,0,0-1.3,1.778l.827,5.29a1.557,1.557,0,0,0,1.778,1.3l1.991-.311a15.514,15.514,0,0,0,1.948,3.192l-1.188,1.629a1.554,1.554,0,0,0,.339,2.175l4.326,3.156a1.556,1.556,0,0,0,2.175-.339l1.188-1.629a15.5,15.5,0,0,0,3.635.881l.312,1.991a1.557,1.557,0,0,0,1.778,1.3l5.29-.829A1.555,1.555,0,0,0,91.2,172.415ZM74.4,157.707a10.087,10.087,0,1,1,11.524,8.409A10.086,10.086,0,0,1,74.4,157.707Z",
    transform: "translate(-65.479 -137.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M83.324,150.267a4.234,4.234,0,1,0-3.53,4.838A4.234,4.234,0,0,0,83.324,150.267Z",
    transform: "translate(-60.251 -132.032)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.366 17.547)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M86.681,133.886l1.628,1.188a15.55,15.55,0,0,0-.88,3.636l-1.991.311a1.555,1.555,0,0,0-1.3,1.778l.827,5.29a1.556,1.556,0,0,0,1.778,1.3l1.991-.311a15.634,15.634,0,0,0,1.946,3.193L89.494,151.9a1.556,1.556,0,0,0,.34,2.175l4.326,3.156a1.556,1.556,0,0,0,2.175-.339l1.188-1.628a15.556,15.556,0,0,0,3.635.88l.311,1.991a1.559,1.559,0,0,0,1.778,1.3l5.292-.827a1.559,1.559,0,0,0,1.3-1.778l-.312-1.991a15.6,15.6,0,0,0,3.193-1.948l1.629,1.188a1.556,1.556,0,0,0,2.175-.34l3.156-4.325a1.558,1.558,0,0,0-.34-2.176l-1.628-1.188a15.558,15.558,0,0,0,.88-3.635l1.991-.311a1.558,1.558,0,0,0,1.3-1.778l-.827-5.292a1.555,1.555,0,0,0-1.778-1.3l-1.991.311a15.633,15.633,0,0,0-1.946-3.193l1.188-1.628a1.556,1.556,0,0,0-.34-2.175l-4.326-3.157a1.556,1.556,0,0,0-2.175.34l-1.188,1.628a15.558,15.558,0,0,0-3.635-.88l-.311-1.991a1.559,1.559,0,0,0-1.778-1.3l-5.292.827a1.559,1.559,0,0,0-1.3,1.778l.311,1.991a15.6,15.6,0,0,0-3.192,1.948l-1.629-1.188a1.557,1.557,0,0,0-2.175.339l-3.156,4.326A1.556,1.556,0,0,0,86.681,133.886Zm22.274-1.475a10.087,10.087,0,1,1-14.1,2.2A10.089,10.089,0,0,1,108.954,132.411Z",
    transform: "translate(-84.12 -121.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M95.285,138.752a4.234,4.234,0,1,0-.925-5.917A4.233,4.233,0,0,0,95.285,138.752Z",
    transform: "translate(-78.892 -116.442)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDeviceDriver);
export default __webpack_public_path__ + "static/media/icn-device-driver.c7784e3355420f2574730896966b63d6.svg";
export { ForwardRef as ReactComponent };